import { useMemo } from 'react';
import { PolylineProps, PushpinProps } from '../../../types/MapModels';
import { MapBounds } from './AzureMapUtils';

interface UseAzureMapCameraProps {
    pushpinsProp?: PushpinProps[];
    loadBubblePins?: PushpinProps[];
    alightingsBubblePins?: PushpinProps[];
    boardBubblePins?: PushpinProps[];
    polylinesProp?: PolylineProps[];
    disableAutoCamera?: boolean;
}

export const useAzureMapCamera = ({
    pushpinsProp,
    loadBubblePins,
    alightingsBubblePins,
    boardBubblePins,
    polylinesProp,
    disableAutoCamera,
}: UseAzureMapCameraProps) => {
    return useMemo<MapBounds | null>(() => {
        if (disableAutoCamera) {
            return null;
        }

        let bounds: MapBounds | null = null;
        const extend = (lat?: number, lon?: number) => {
            if (typeof lat !== 'number' || typeof lon !== 'number' || Number.isNaN(lat) || Number.isNaN(lon)) {
                return;
            }
            if (!bounds) {
                bounds = { north: lat, south: lat, east: lon, west: lon };
                return;
            }
            bounds = {
                north: Math.max(bounds.north, lat),
                south: Math.min(bounds.south, lat),
                east: Math.max(bounds.east, lon),
                west: Math.min(bounds.west, lon),
            };
        };

        const addFromPins = (pins?: PushpinProps[]) => {
            (pins || []).forEach(pin => {
                if (pin?.location) {
                    extend(pin.location[0], pin.location[1]);
                }
            });
        };

        addFromPins(pushpinsProp);
        addFromPins(loadBubblePins);
        addFromPins(alightingsBubblePins);
        addFromPins(boardBubblePins);

        (polylinesProp || []).forEach(poly => {
            (poly.locations || []).forEach(location => extend(location[0], location[1]));
        });

        return bounds;
    }, [pushpinsProp, loadBubblePins, alightingsBubblePins, boardBubblePins, polylinesProp, disableAutoCamera]);
};
